// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "BusinessProGuestLazyComponent" + "." + "54ac5183ea10893d1aa0" + ".css";
};